import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useProcessClaimsMutation } from '../../redux/services/processClaimsApi';

const ProcessClaimsScreen = props => {
  const [process, response] = useProcessClaimsMutation();
  const onClick = ({workflow}) => async e => process({workflow});
  return (
    <Paper>
      <Stack alignItems='center' padding={4} spacing={2}>
        <Typography variant='h1'>
          Manage Claims
        </Typography>
        {
          response?.error && 
          <Alert severity='error'>
            Error processing claims
          </Alert>
        }
        {
          response?.data && 
          <Alert severity='success'>
            {response?.data?.data?.process_claims}
          </Alert>
        }
        <Button
          color='success'
          variant='contained'
          onClick={onClick({workflow: 'transmit_claims'})}
        >
          Transmit Claims
        </Button>
        <Typography variant='body'>
          Upload claims to WayStar
        </Typography>
        <Button
          color='error'
          variant='contained'
          onClick={onClick({workflow: 'upload_claim_attachments'})}
        >
          Attach Notes to Claims
        </Button>
        <Typography variant='body'>
          You must first wait for WayStar to have received and generated them.
        </Typography>
      </Stack>
    </Paper>
  );
};

export default ProcessClaimsScreen;